export const createDefaultTailwindContextValue = (defaultValue: any | undefined = undefined) => defaultValue;

export default createDefaultTailwindContextValue;
